import { useEffect } from 'react'

/**
 * Guard de "trabajo sin guardar" (auditoría 1 jul 2026 — una NV de 15 renglones
 * se perdía con un F5 o un click al sidebar):
 *  (a) beforeunload frena F5 / cerrar pestaña con el diálogo nativo;
 *  (b) window.__lgrDirty lo consulta el Layout antes de navegar por el menú
 *      (SPA no dispara beforeunload) y los botones ← Volver / Cancelar de los
 *      forms vía confirmarSiSucio().
 * El flag se limpia al desmontar el form (submit OK navega → desmonta → limpio).
 */
export default function useDirtyGuard(dirty, mensaje = 'Tenés cambios sin guardar en este formulario. ¿Salir igual?') {
  useEffect(() => {
    window.__lgrDirty = dirty ? mensaje : null
    const onBeforeUnload = (e) => {
      if (!window.__lgrDirty) return
      e.preventDefault()
      e.returnValue = mensaje
    }
    window.addEventListener('beforeunload', onBeforeUnload)
    return () => {
      window.__lgrDirty = null
      window.removeEventListener('beforeunload', onBeforeUnload)
    }
  }, [dirty, mensaje])
}

/** true si se puede salir (no hay cambios, o el usuario confirmó perderlos). */
export function confirmarSiSucio() {
  return !window.__lgrDirty || window.confirm(window.__lgrDirty)
}
